var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"navigation"},[_c('div',{staticClass:"minbox"},[_vm._v("执业药师继续教育登录入口")])])])}]

export { render, staticRenderFns }